import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { BackHeader, PageTemplate } from '@_widgets/common';

import { userApi } from '@_entities/user';
import TokenManager from '@_shared/config/tokenManager';
import { SkeletonUI } from '@_shared/ui';
import { Button } from '@_shared/ui/Button';
import { Typography } from '@_shared/ui/Typography';
import * as S from './LeavePage.style';

const reasonMap = [
	{ value: 'WDRL01', text: '재가입' },
	{ value: 'WDRL02', text: '이용 빈도 및 기대감이 낮음' },
	{ value: 'WDRL03', text: '콘텐츠 및 장소 정보의 부족' },
	{ value: 'WDRL04', text: '개인정보보호 및 보안' },
	{ value: 'WDRL05', text: '다른 서비스로의 이동' },
	{ value: 'WDRL06', text: '기타' },
];

export function LeavePage() {
	const navigate = useNavigate();
	const [nickname, setNickname] = useState<string>();

	const [selectedReason, setSelectedReason] = useState<string[]>([]);
	const [etcText, setEtcText] = useState<string>();

	function checkReason(code: string) {
		if (selectedReason.includes(code)) {
			setSelectedReason((prev) => prev.filter((reason) => reason !== code));
		} else {
			setSelectedReason((prev) => [code, ...prev]);
		}
	}

	useEffect(() => {
		userApi.getUser().then(({ data: responseData }) => {
			setNickname(responseData.nickname);
		});
	}, []);

	return (
		<PageTemplate
			header={<BackHeader>회원 탈퇴</BackHeader>}
			nav={
				<S.BottomButtonsContainer>
					<Button
						bgColor="warmgray-300"
						fullWidth
						height="50px"
						onClick={() => {
							navigate(-1);
						}}
					>
						<Typography type="title-large" color="white-primary">
							취소
						</Typography>
					</Button>
					<Button
						fullWidth
						height="50px"
						onClick={() => {
							userApi.leaveUser(selectedReason, etcText).then(() => {
								navigate('/user/leave_done');
								TokenManager.logout();
							});
						}}
					>
						<Typography type="title-large" color="white-primary">
							탈퇴하기
						</Typography>
					</Button>
				</S.BottomButtonsContainer>
			}
		>
			<S.Container>
				<S.TitleContainer>
					<Typography type="headline-small" color="font-primary">
						정말로 탈퇴하시겠어요?
					</Typography>
					<Typography type="body-large" color="font-tertiary">
						{nickname === undefined ? (
							<>
								<SkeletonUI width="220px" height="36px" borderRadius="8px" />
							</>
						) : (
							<>
								<S.Nickname>{nickname}</S.Nickname> 님의 아래 정보는 모두 삭제되며,
								<br />
								탈퇴 시 정보 복구가 어려워요.
							</>
						)}
					</Typography>
				</S.TitleContainer>
				<S.ContentContainer>
					<S.ReasonHeader>
						<Typography type="title-medium" color="font-primary">
							딸깍을 탈퇴하려는 이유가 무엇인가요? <S.WarnText>*필수</S.WarnText>
						</Typography>
						<Typography type="title-small" color="font-primary">
							(복수 선택 가능)
						</Typography>
					</S.ReasonHeader>
					<S.ReasonContainer>
						{reasonMap.map((reason) => (
							<S.ReasonItem key={`reson ${reason.value}`}>
								<input
									type="checkbox"
									value={reason.value}
									id={`reason ${reason.value}`}
									onInput={(e) => {
										checkReason(e.currentTarget.value);
									}}
								/>
								<label htmlFor={`reason ${reason.value}`}>
									<Typography type="body-large" color="font-secondary">
										{reason.text}
									</Typography>
								</label>
								{selectedReason.includes('WDRL06') && reason.value === 'WDRL06' && (
									<input
										type="text"
										maxLength={20}
										name="etc"
										placeholder="이유를 입력해 주세요. (20자 이내)"
										value={etcText}
										onInput={(e) => {
											setEtcText(e.currentTarget.value);
										}}
									/>
								)}
							</S.ReasonItem>
						))}
					</S.ReasonContainer>
				</S.ContentContainer>
				<S.ContentContainer>
					<Typography type="title-medium" color="font-primary">
						회원탈퇴 유의사항
					</Typography>
					<ul>
						<li>
							<Typography type="body-large" color="font-secondary">
								회원을 탈퇴할 경우 계정과 프로필 정보 및 딸깍에 저장한 모든 콘텐츠가
								삭제됩니다.
							</Typography>
						</li>
						<li>
							<Typography type="body-large" color="font-secondary">
								회원을 탈퇴한 이후 같은 계정으로 재가입하더라도 삭제된 정보는
								복구되지 않습니다.
							</Typography>
						</li>
					</ul>
				</S.ContentContainer>
			</S.Container>
		</PageTemplate>
	);
}
